import LogRocket from 'logrocket';
import { getTowerVersion, getInputValue } from './modules/utils';

let logging = false;
export function startLog(userId, appID = 'xrq7ho/tower-200602', params = {}) {
  if (process.env.NODE_ENV !== 'production') return;

  if (!logging) {
    LogRocket.init(appID, {
      release: getTowerVersion(),
    });
    logging = true;
  }

  LogRocket.identify(userId, Object.assign({
    name: getInputValue('#user-name'),
    email: getInputValue('#user-email'),
    teamId: getInputValue('#team-id'),
    teamGuid: getInputValue('#team-guid'),
    teamName: getInputValue('#team-name'),
    member: getInputValue('#member-id'),
    avatar: getInputValue('#member-avatar'),
    isOwner: !!document.querySelector('input[type="hidden"]#member-owner'),
  }, params));
}

document.addEventListener('DOMContentLoaded', () => {
  const trackUser = getInputValue('#track-user-id');
  if (trackUser) startLog(trackUser);
}, { once: true });
